import React, { FunctionComponent, SVGProps } from "react";

export const DownloadIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M12 3a.75.75 0 0 1 .75.75v8.69l2.657-2.657a.75.75 0 0 1 1.06 1.06L12.53 14.78a.75.75 0 0 1-1.06 0l-3.938-3.936a.75.75 0 1 1 1.06-1.06l2.658 2.656V3.75A.75.75 0 0 1 12 3ZM3.75 13.5a.75.75 0 0 1 .75.75v5.25h15v-5.25a.75.75 0 0 1 1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-5.25a.75.75 0 0 1 .75-.75Z"
        fill="#64748B"
        fillRule="evenodd"
      />
    </svg>
  );
};
